module.exports = __webpack_public_path__ + "assets/d365035a89e0c7ce8f49e44d0db7bc4f.png";